import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import ContactSection from './ContactSection';
import LocationSection from './LocationSection';
import WhatsAppSupport from './WhatsappSupport';
import ScrollToTop from './ScrollToTop';
import { Link } from 'react-router-dom';
import { MegaMenu } from './MegaMenu';

const ContactPage = () => {


  return (
    <div className="bg-gray-50 text-gray-800">
      {/* <Navbar /> */}
      <MegaMenu/>

      {/* Hero Section */}
      <div className="relative h-[100vh]">
        {/* Background Image */}
        <div className="absolute inset-0 h-full">
          <img
            src="https://images.unsplash.com/photo-1523050854058-8df90110c9f1?q=80&w=2626&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Overlay Content */}
        <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-6 md:px-8 lg:px-16 bg-black bg-opacity-60 space-y-3">
          <h1 className="text-white text-2xl sm:text-4xl md:text-5xl lg:text-7xl font-bold leading-tight lg:leading-snug noto">
          We’re Here to Help
          </h1>
          <p className=' text-white hidden sm:block'>Unlock your potential with our overseas education programs and educational tours. Discover diverse cultures,<br /> gain invaluable knowledge, and accelerate your academic and personal growth through transformative global experiences.</p>
          <h5 className=' text-white text-xs lg:hidden'>Unlock global learning experiences and cultural tours that will expand your knowledge and broaden your horizons abroad.</h5>


        </div>
      </div>

      <ContactSection />
      <LocationSection />
      <section className="bg-gray-900 text-white py-20 text-center relative">
        {/* Background Overlay */}
        <div className="absolute inset-0  "></div>

        {/* Content Wrapper */}
        <div className="relative z-10 px-6">
          {/* Title */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-6 leading-tight">
            Join Us in Transforming Futures
          </h2>

          {/* Subtitle */}
          <p className="mb-8 text-base sm:text-lg max-w-2xl mx-auto">
            Ready to take the next step in your educational journey? Discover how ApplicationUni can support your dreams of studying abroad.
          </p>

          {/* Button */}
          <Link
            to="/eligibility"
            className="inline-block bg-white text-black font-bold py-3 sm:py-4 px-8 sm:px-12 rounded-full hover:bg-gray-200 transition-all"
          >
            Apply Now
          </Link>
        </div>
      </section>
      {/* <WhatsAppSupport/> */}
      <ScrollToTop />
      <Footer />
    </div>
  );
};

export default ContactPage;
